import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone',
})
export class PhonePipe implements PipeTransform {
  transform(rawNum: string): string {
    if (rawNum.length === 0) return '';

    const countryCodeStr = rawNum.slice(0, 3);
    const areaCodeStr = rawNum.slice(3, 6);
    const midSectionStr = rawNum.slice(6, 9);
    const lastSectionStr = rawNum.slice(9);

    let formattedNum = '';

    if (countryCodeStr) formattedNum += countryCodeStr;
    if (areaCodeStr) formattedNum += ` ${areaCodeStr}`;
    if (midSectionStr) formattedNum += ` ${midSectionStr}`;
    if (lastSectionStr) formattedNum += ` ${lastSectionStr}`;

    return formattedNum.trim();
  }
}
